import { motion } from "framer-motion";
import { useI18n } from "../i18n";

const VIDEOS = [
  {
    id: "v1",
    title_ru: "Team Astana — выступление",
    title_en: "Team Astana — performance",
    embed: "https://www.youtube.com/embed/qtkVt-bBz3Y",
  },
  {
    id: "v2",
    title_ru: "Team Astana — выступление",
    title_en: "Team Astana — performance",
    embed: "https://www.youtube.com/embed/uiEqbKwsaN8",
  },
  {
    id: "v3",
    title_ru: "Team Astana — выступление",
    title_en: "Team Astana — performance",
    embed: "https://www.youtube.com/embed/26OAnFnoYkA",
  },
];

const Videos = () => {
  const { t, lang } = useI18n();

  return (
    <section id="videos" data-testid="videos-section" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="mb-12">
          <div className="kicker mb-4">{t.videos.kicker}</div>
          <h2
            className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter"
            data-testid="videos-title"
          >
            {t.videos.title}
          </h2>
          <p className="mt-4 text-white/60 max-w-md">{t.videos.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Main featured video */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:row-span-2 border border-white/15"
            data-testid={`video-${VIDEOS[0].id}`}
          >
            <div className="relative aspect-video bg-black">
              <iframe
                src={VIDEOS[0].embed}
                title={lang === "ru" ? VIDEOS[0].title_ru : VIDEOS[0].title_en}
                className="absolute inset-0 w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <div className="p-5 border-t border-white/15">
              <div className="text-[10px] tracking-widest text-[#FFDE00] uppercase mb-1">
                Featured
              </div>
              <div className="font-display text-2xl tracking-tight">
                {lang === "ru" ? VIDEOS[0].title_ru : VIDEOS[0].title_en}
              </div>
            </div>
          </motion.div>

          {VIDEOS.slice(1).map((v, i) => (
            <motion.div
              key={v.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 * (i + 1) }}
              className="border border-white/15"
              data-testid={`video-${v.id}`}
            >
              <div className="relative aspect-video bg-black">
                <iframe
                  src={v.embed}
                  title={lang === "ru" ? v.title_ru : v.title_en}
                  className="absolute inset-0 w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="p-4 border-t border-white/15">
                <div className="font-display text-xl tracking-tight">
                  {lang === "ru" ? v.title_ru : v.title_en}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Videos;
